import Reveal from "./Reveal";

const pillars = [
  {
    icon: "ri-radar-line",
    title: "Proactive",
    desc: "Identify and resolve technology issues before they become costly business problems.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Secure",
    desc: "Build security into your technology environment from the ground up.",
  },
  {
    icon: "ri-compass-3-line",
    title: "Strategic",
    desc: "Make technology decisions based on your business objectives, not just today's problems.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Reliable",
    desc: "Have an experienced technology partner you can count on when your business needs support.",
  },
];

const hubLabels = [
  { label: "Proactive", icon: "ri-radar-line", position: "top-0 left-1/2 -translate-x-1/2" },
  { label: "Secure", icon: "ri-lock-2-line", position: "top-1/2 right-0 -translate-y-1/2" },
  { label: "Strategic", icon: "ri-compass-3-line", position: "bottom-0 left-1/2 -translate-x-1/2" },
  { label: "Reliable", icon: "ri-hand-heart-line", position: "top-1/2 left-0 -translate-y-1/2" },
];

export default function ValueProposition() {
  return (
    <section id="value" className="py-20 md:py-28 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <Reveal>
            <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              Our Approach
            </span>
            <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
              More Than IT Support. Your Technology Partner.
            </h2>
            <p className="mt-5 text-foreground-600 text-base md:text-lg leading-relaxed">
              We're not just the company you call when something breaks. The Tech Consultants LLC
              is a strategic technology partner that proactively manages your entire IT
              environment — helping you reduce risk, improve productivity, and build a foundation
              for long-term growth.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {pillars.map((p, i) => (
                <Reveal key={p.title} delay={i * 80}>
                  <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="w-10 h-10 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                      <i className={`${p.icon} text-lg`} />
                    </span>
                    <div>
                      <h3 className="font-heading font-bold text-foreground-900 text-sm">
                        {p.title}
                      </h3>
                      <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </Reveal>

          {/* Ecosystem visual */}
          <Reveal delay={100}>
            <div className="relative aspect-square max-w-md mx-auto w-full">
              {/* concentric rings */}
              <div className="absolute inset-0 rounded-full border border-primary-200" />
              <div className="absolute inset-[18%] rounded-full border border-primary-300" />
              <div className="absolute inset-[34%] rounded-full border border-accent-300" />

              {/* center hub */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-28 h-28 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-primary-500 to-accent-400 flex flex-col items-center justify-center text-white">
                  <i className="ri-shield-star-line text-3xl md:text-4xl" />
                  <span className="mt-1 text-[11px] font-semibold tracking-wide">Your Business</span>
                </div>
              </div>

              {/* orbiting labels */}
              {hubLabels.map((h) => (
                <span
                  key={h.label}
                  className={`absolute ${h.position} inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-white px-3 py-1.5 text-xs font-semibold text-foreground-700`}
                >
                  <i className={`${h.icon} text-primary-500`} />
                  {h.label}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}